<ion-header class="ion-no-border">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button autoHide="false"></ion-menu-button>
    </ion-buttons>
    <ion-title class="ion-text-center app-title">
      Hypertension <br>Predictor
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="home-gradient-bg">
  <!-- HERO ------------------------------------------------------- -->
  <div class="hero-section ion-padding">
    <div class="logo-placeholder animate__animated animate__fadeInDown">
      <ion-icon name="heart-half-outline"></ion-icon>
    </div>

    <h1 class="animate__animated animate__fadeInUp">
      {{ 'HOME.HEADING' | translate }}
    </h1>

    <!-- CALL-TO-ACTION -------------------------------------------- -->
    <div class="cta-section animate__animated animate__fadeInUp animate__delay-1s">
      <ion-button routerLink="/input" expand="block" class="primary-button-lg">
        <ion-icon slot="start" name="analytics-outline"></ion-icon>
        {{ 'HOME.START_BUTTON' | translate }}
      </ion-button>
    </div>

    <p class="description animate__animated animate__fadeInUp animate__delay-0-5s">
      {{ 'HOME.DESCRIPTION_1' | translate }}
      <strong>Machine Learning</strong>
      {{ 'HOME.DESCRIPTION_2' | translate }}
      <strong>Deep Learning</strong>
      {{ 'HOME.DESCRIPTION_3' | translate }}
      <strong>{{ 'HOME.DISEASE' | translate }}</strong>
      {{ 'HOME.DESCRIPTION_4' | translate }}
      <a
        href="https://doi.org/10.3934/math.2025283"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="DOI: 10.3934/math.2025283"
      >
        <ion-icon name="document-text-outline"></ion-icon>
      </a>
    </p>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar color="primary" class="footer-toolbar">
    <div class="footer-content">
      <div class="footer-item">
        © 2025 Hypertension Predictor
      </div>
      <div class="footer-item">
        <a routerLink="/contact">{{ 'NAV.CONTACT' | translate }}</a> |
      </div>
      <div class="footer-item social">
        <a
          href="https://web.facebook.com/profile.php?id=61567342078201"
          target="_blank"
          rel="noopener noreferrer"
        >
          <ion-icon name="logo-facebook"></ion-icon>
        </a>
      </div>
    </div>
  </ion-toolbar>
</ion-footer>
